export default __webpack_public_path__ + "successIcon.svg";